import dayjs from "./plugins";

import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT } from "./constants";

const DateHelper = {
  /**
   * Date, Date Time Getters / Formatters
   */
  currentDate: () => dayjs().format(DEFAULT_DATE_FORMAT),

  currentDateTime: () => dayjs().format(DEFAULT_DATE_TIME_FORMAT),

  dateFormatter: (date, { tz, format } = {}) => {
    //dayjs(undefined) is same as dayjs()
    const d = date ? date : undefined;

    if (format && tz) return dayjs.tz(d, tz).format(format);
    if (tz) return dayjs.tz(d, tz);
    if (format) return dayjs(d).format(format);

    return dayjs(d);
  },

  currentDateTimeInZone: (zone) => {
    return dayjs.tz(undefined, zone);
  },

  getFormattedDate: (date = dayjs(), format = DEFAULT_DATE_FORMAT) => dayjs(date).format(format),

  /**
   * Date Manipulators
   */
  getUnitFromDate: (date, unit) => dayjs(date).get(unit),

  add: (date, amount, unit) => dayjs(date).add(amount, unit),

  subtract: (date, amount, unit) => dayjs(date).subtract(amount, unit),

  diff: (from, to, unit) => dayjs(from).diff(to, unit),

  isAfter: (datePrimary, dateSecondary, unit = null) => {
    if (unit) {
      return dayjs(datePrimary).isAfter(dateSecondary, unit);
    }
    return dayjs(datePrimary).isAfter(dateSecondary);
  },

  isBefore: (datePrimary, dateSecondary, unit = null) => {
    if (unit) {
      return dayjs(datePrimary).isBefore(dateSecondary, unit);
    }
    return dayjs(datePrimary).isBefore(dateSecondary);
  },

  isSame: (datePrimary, dateSecondary, unit = null) => {
    if (unit) {
      return dayjs(datePrimary).isSame(dateSecondary, unit);
    }
    return dayjs(datePrimary).isSame(dateSecondary);
  },

  isSameOrAfter: (datePrimary, dateSecondary, unit = null) => {
    if (unit) {
      return dayjs(datePrimary).isSameOrAfter(dateSecondary, unit);
    }
    return dayjs(datePrimary).isSameOrAfter(dateSecondary);
  },

  isSameOrBefore: (datePrimary, dateSecondary, unit = null) => {
    if (unit) {
      return dayjs(datePrimary).isSameOrBefore(dateSecondary, unit);
    }
    return dayjs(datePrimary).isSameOrBefore(dateSecondary);
  },

  set: (datePrimary, params) => {
    // datePrimary can be a string date or a dayjs object
    let finalDate = dayjs.isDayjs(datePrimary) ? datePrimary : dayjs(datePrimary);
    Object.keys(params).forEach((param) => {
      finalDate = finalDate.set(param, params[param]);
    });

    return finalDate;
  },

  startOf: (datePrimary, unit) => dayjs(datePrimary).startOf(unit),

  endOf: (datePrimary, unit) => dayjs(datePrimary).endOf(unit),

  /**
   * Zones
   */

  getZone: () => dayjs.tz.guess(),

  /**
   * Date Checkers
   */
  isValid: (dateObj) => dateObj.isValid(),

  isWeekDay: (dateObj) => dateObj.day() !== 6 && dateObj.day() !== 0,

  isPastDay: (dateObj) => dateObj.diff(dayjs(), "days") < 0,

  //day js max pass null value if user send only one date in array
  getLatestDate: (receivedDates) =>
    receivedDates.length > 1
      ? dayjs.max(...receivedDates.map((e) => dayjs(e)))
      : dayjs(receivedDates[0]),
};

export const {
  currentDate,
  currentDateTime,
  getFormattedDate,
  dateFormatter,
  getUnitFromDate,
  add,
  subtract,
  diff,
  isAfter,
  isBefore,
  isSame,
  isSameOrAfter,
  isSameOrBefore,
  set,
  isValid,
  startOf,
  endOf,
  getZone,
  isWeekDay,
  isPastDay,
  currentDateTimeInZone,
  getLatestDate,
} = DateHelper;

export default dayjs;
